import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/groups/$groupId')({
  component: GroupDetailPage,
})

function GroupDetailPage() {
  const { groupId } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Group Details
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                View group information and member management
              </p>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Group ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {groupId}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Group Information (To be implemented)
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
                <li>Group name and description</li>
                <li>Member list with roles</li>
                <li>Group permissions and features</li>
                <li>Document access and sharing settings</li>
                <li>Add/remove members functionality</li>
                <li>Group activity timeline</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
